module.exports = __webpack_public_path__ + "static/media/kansas.369d037d.jpg";